export default __webpack_public_path__ + "static/media/pexels-victor-fevrier-15879065.d9710a05.jpg";